/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { css, jsx } from "@emotion/react";
import { TopUpcomingEvent } from "components/top/TopUpcomingEvent";
import { ArchiveEventListLogic } from "containers/top/ArchiveEventList";
import { useGetEventList } from "hooks/event/useGetEventList";
import { useBrandEventDisplay } from "hooks/useBrandEventDisplay";
import React from "react";

export const BrandInitialEventDisplay = () => {
  // 今後のイベント
  const { data: comingEvents, isLoading: comingEventIsLoading } =
    useGetEventList({
      type: "coming",
      limit: 30,
    });

  // アーカイブ配信中のイベント
  const { data: vodEvents, isLoading: vodEventIsLoading } = useGetEventList({
    type: "openVOD",
    limit: 6,
  });

  // 終了したイベント
  const { data: archiveEvents, isLoading: archiveEventIsLoading } =
    useGetEventList({
      type: "archive",
      limit: 6,
      enabled: () =>
        !comingEventIsLoading &&
        !comingEvents?.length &&
        !vodEventIsLoading &&
        !vodEvents?.length,
    });

  const isLoading =
    comingEventIsLoading || vodEventIsLoading || archiveEventIsLoading;

  const { displayEvents, upcomingEventType } = useBrandEventDisplay({
    archiveEvents,
    comingEvents,
    vodEvents,
    isLoading,
  });

  return (
    <>
      {/* ArchiveEventListLogic */}
      <div
        css={css`
          padding-top: 60px;
          @media screen and (min-width: 768px) {
            padding-top: 80px;
          }
        `}
      >
        <ArchiveEventListLogic vodEvents={vodEvents} />
      </div>

      {/* TopUpcomingEvent */}
      <div
        css={css`
          padding-top: 60px;
          @media screen and (min-width: 768px) {
            padding-top: 80px;
          }
        `}
      >
        <TopUpcomingEvent
          topInfo={{ featureEventIds: [] }}
          displayEvents={displayEvents}
          upcomingEventType={upcomingEventType}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};
